import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import ProductSameItem from "./ProductSameItem.jsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Commit from "./Commit.jsx";
import { formatCurrencyVND } from "../utils/CurrencyFormat.js";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";

const orther = [
  'Giảm 30.000đ khi đặt online nhập "VF30K"',
  "Tặng Thiệp/Banner",
  "Cam kết giao đúng giờ",
  "Đặt là có giao ngay. Miễn phí giao hoa nội thành",
  "Hình ảnh sẽ được gửi trước và sau khi giao xong",
  "Cam kết 100% hoàn tiền nếu Bạn không hài lòng",
];

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isZoomed, setIsZoomed] = useState(false);
  const [product, setProduct] = useState({});
  const [category, setCategory] = useState({});
  const [productSame, setProductSame] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    getProduct(id);
  }, [id]);

  const getProduct = (id) => {
    axios
      .get(`/api/v1/products/get-by-slug/` + id)
      .then((res) => {
        if (res.data == null) {
          navigate(`/not-found`);
        }
        document.title = res.data.name;
        setProduct(res.data);
        getCategory(res.data.categoryId);
      })
      .catch((err) => console.log(err));
  };

  const getCategory = (id) => {
    axios
      .get(`/api/v1/categories/` + id)
      .then((res) => {
        setCategory(res.data);
        getProductSame(res.data.id);
      })
      .catch((err) => console.log(err));
  };

  const getProductSame = (cateId) => {
    axios
      .get(`/api/v1/products`, {
        params: {
          categoryId: cateId,
          limit: 10,
          page: 1,
        },
      })
      .then((res) => {
        setProductSame(res.data.products);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const handleImageClick = () => {
    setIsZoomed(true);
  };

  const closeZoom = () => {
    setIsZoomed(false);
  };

  useEffect(() => {
    if (isZoomed) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isZoomed]);

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style }} onClick={onClick} />;
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return <div className={className} style={{ ...style }} onClick={onClick} />;
  };

  const handleQuickBuy = () => {
    // if (clientId == 0) {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    let existingProduct = cart.find((item) => item.product.id === product.id);

    if (existingProduct) {
      existingProduct.quantity += 1;
    } else {
      const formatData = {
        product: product,
        quantity: 1,
      };
      cart.push(formatData);
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    navigate(`/cart`);
    // } else {
    //   axios
    //     .get(`/api/v1/orders/customer/` + clientId)
    //     .then((res) => {
    //       getOrderDetails(res.data[0].id, clientId);
    //     })
    //     .catch((err) => console.log(err));
    // }
  };

  // const getOrderDetails = (orderId, cusId) => {
  //   axios
  //     .get(`/api/v1/order-details`, {
  //       orderId: orderId,
  //       customerId: cusId,
  //     })
  //     .then((res) => {
  //       if (res.data.orderDetails.length == 0) {
  //         addProductToCart(orderId);
  //       } else {
  //         const matchedItem = res.data.orderDetails.find(
  //           (item) => item.productId === product.id
  //         );
  //         if (matchedItem) {
  //           plusQuantityToProduct(matchedItem.id, orderId);
  //         } else {
  //           addProductToCart(orderId);
  //         }
  //       }
  //       navigate(`/cart`);
  //     })
  //     .catch((err) => console.log(err));
  // };

  // const addProductToCart = (orderId) => {
  //   axios
  //     .post(`/api/v1/order-details`, {
  //       orderId: orderId,
  //       productId: product.id,
  //       quantity: 1,
  //     })
  //     .then((res) => {
  //       toast("Thêm sản phẩm vào giỏ hàng thành công!", {
  //         type: "success",
  //         autoClose: 1000,
  //       });
  //     })
  //     .catch((err) => console.log(err));
  // };

  // const plusQuantityToProduct = (id, orderId) => {
  //   axios
  //     .put(`/api/v1/order-details/` + id, {
  //       orderId: orderId,
  //       productId: product.id,
  //     })
  //     .then((res) => {
  //       toast("Thêm sản phẩm vào giỏ hàng thành công!", {
  //         type: "success",
  //         autoClose: 1000,
  //       });
  //     })
  //     .catch((err) => console.log(err));
  // };

  const settings = {
    dots: false,
    infinite: productSame.length > 3,
    speed: 500,
    slidesToShow: productSame.length == 1 ? productSame.length : 4,
    slidesToScroll: productSame.length,
    autoplay: productSame.length > 3,
    autoplaySpeed: 2500,
    focusOnSelect: true,
    snapToChildren: true,
    nextArrow: productSame.length > 3 ? <SampleNextArrow /> : <></>,
    prevArrow: productSame.length > 3 ? <SamplePrevArrow /> : <></>,
    responsive: [
      {
        breakpoint: 431,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerPadding: "0",
        },
      },
    ],
  };

  return (
    <Box sx={{ position: "relative", minHeight: "100vh" }}>
      <div className="product-detail-container">
        <div className="product-detail-top mb-3">
          <div className="product-detail-breadcrumb">
            <Link to={`/`}>Trang chủ</Link>
            <div
              style={{
                fontSize: 20,
                color: "#666666B2",
                cursor: "default",
                padding: "0 15px",
              }}
            >
              {" "}
              •{" "}
            </div>
            <Link to={"/" + category.slug}>{category.name}</Link>
            <div
              style={{
                fontSize: 20,
                color: "#666666B2",
                cursor: "default",
                padding: "0 15px",
              }}
            >
              {" "}
              •{" "}
            </div>
            <Link>{product.name}</Link>
          </div>
        </div>
        <div className="product-detail-main-layout">
          <div className="product-detail-content-item">
            {product.discount && (
              <div className="product-detail-badge">-{product.discount}%</div>
            )}
            <div className="product-detail-img-item">
              <img src={product.image} alt="" onClick={handleImageClick} />
            </div>
          </div>
          <div className="product-detail-right">
            <div className="product-detail-title">{product.name}</div>
            {/* <div className="product-detail-code">Mã: {product.code}</div> */}
            {product.salePrice > 0 ? (
              <div className="product-detail-price mb-1">
                <span>{formatCurrencyVND(product.price)}</span>
                <span>{formatCurrencyVND(product.salePrice)}</span>
              </div>
            ) : (
              <div className="product-detail-price-non-discount mb-1">
                <span>{formatCurrencyVND(product.price)}</span>
              </div>
            )}
            <div className="button-quick-buy" onClick={handleQuickBuy}>
              MUA HÀNG NHANH
            </div>
            <div className="product-detail-contact">
              <a href="tel:+84919345169" style={{ textDecoration: "none" }}>
                <div className="product-detail-button-contact">Gọi điện</div>
              </a>
              <a
                href="https://zalo.me/0919345169"
                style={{ textDecoration: "none" }}
              >
                <div className="product-detail-button-contact-zalo">
                  Chat Zalo
                </div>
              </a>
            </div>
            <div className="product-detail-orther">
              {orther.map((item, idx) => (
                <p key={idx}>✅ {item}</p>
              ))}
            </div>
          </div>
        </div>
        <div className="product-detail-description-container mt-4">
          <div className="product-detail-description-title">Mô Tả Sản Phẩm</div>
          <div dangerouslySetInnerHTML={{ __html: product.description }} />
        </div>
        <div className="product-detail-same mt-4">
          <div className="product-detail-same-title">SẢN PHẨM TƯƠNG TỰ</div>
          <Slider {...settings}>
            {productSame.map((item, idx) => (
              <ProductSameItem data={item} key={idx} />
            ))}
          </Slider>
        </div>
        <Commit />
        {isZoomed && (
          <div className="product-detail-overlay" onClick={closeZoom}>
            <img
              src={product.image}
              alt="Zoomed Product"
              className="zoomed-img"
            />
          </div>
        )}
      </div>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <CircularProgress sx={{ color: "#0184b7" }} />
        </Box>
      )}
    </Box>
  );
};

export default ProductDetail;
